import { BaseSmartDBFrontEndTxApiCalls } from 'smart-db';
import { ProtocolEntity } from '../Entities/Protocol.Entity';

export class ProtocolApi extends BaseSmartDBFrontEndTxApiCalls {
    protected static _Entity = ProtocolEntity;

    // #region api

    // #endregion api
}
